import type { SVGProps } from "react"

export default function HamburgerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line
        x1="0"
        y1="1.25"
        x2="19"
        y2="1.25"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <line
        x1="0"
        y1="7"
        x2="19"
        y2="7"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <line
        x1="0"
        y1="12.75"
        x2="19"
        y2="12.75"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
